export default __webpack_public_path__ + "b696872cc59369481cfc975e07389c25.png";